const cookieTypes = {
  'required_cookies': {
    'value': '1',
    'disabled': true,
    'name': 'Functional cookies',
    'desc': 'Functional cookies help create well usable website pages by enabling basic functionality, such as page navigation and access to protected website sections. Website pages cannot function properly without these cookies. The applicable legislation allows cookies to be stored on your device if such are required for the web pages to function.'
  },
  'preferential_cookies': {
    'value': '1',
    'disabled': false,
    'name': 'Preferencial cookies',
    'desc': 'Preferential cookies allow the website to remember information which may change how the website interacts or appears.'
  },
  'analytics_cookies': {
    'value': '1',
    'disabled': false,
    'name': 'Statistical marketing cookies',
    'desc': 'Analytical and statistical cookies help website owners understand how to communicate with website visitors by using anonymous collection and reporting of information. Marketing cookies are used to track our visitors across websites. Their objective is to show advertisements which are relevant and engaging for individual users, and thereby more valuable to publishers and third-party advertisers.'
  }
}

export default cookieTypes



// WEBPACK FOOTER //
// ./src/components/cookieTypes.js